// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"d920893b","33":"5d78545c","92":"b9af1943","148":"568b5989","155":"bc6568ea","210":"d752b7b3","225":"78543e52","262":"30962fb2","334":"6351cd60","453":"0e9984c3","589":"b2aed828","640":"c437717b","826":"a6998e20"}[chunkId] + ".chunk.js";
};